<template>
  <div class="produit-usage_text_listing">
    <p>{{ text }}</p>
    <button
      v-if="!all && list.length > 10"
      @click="all = !all"
    >
      Tout afficher <div class="chevron">&rsaquo;</div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'DynamicTextListing',
  props: {
    list: Array
  },

  data () {
    return {
      all: false
    }
  },

  computed: {
    text () {
      return this.all ? this.list.join(', ') : (
        this.list.length > 10 ? this.list.slice(0, 10).join(', ') + ', ...' : this.list.join(', ')
      )
    }
  }
}
</script>
